import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import LogInComponent from '../LogInComponent/LogInComponent';

class OwnerLoginPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
        this.clearAlert = this.clearAlert.bind(this);
    }

    clearAlert() {
        this.setState({error: '', errorTitle: ''});
    }

    handleError(error) {
        this.setState({error});
    }

    onClose = () => {
        this.props.updatePage('checkSecurity');
    }

    render() {
        const passwordType = this.props.passwordType !== '' ? this.props.passwordType : 'password';
        let cardContent = (
            <LogInComponent
                {...this.props}
                handleError={this.handleError}
                onClose={this.onClose}
                updatePage={this.props.updatePage}
                passwordType = {passwordType}
                isEmailEditable
            />);
        return (
            <div className="OwnerLoginPageComponent border-border-color">
                <HeaderSectionComponent title={this.props.lingua.read('lex.header.owner')} subtitle={this.props.lingua.read('lex.header.owner.subtitle')}/>
                <CalloutCardComponent content = {cardContent} error={this.state.error} errorTitle={this.state.errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default OwnerLoginPageComponent;
